import axios from "axios";
import { dashboardApi } from "../api/index.js";
import { toast } from "react-toastify";
import { START_LOADING, END_LOADING } from "../constants/webOrderConstants";
import {
  CREATE_CATEGORY,
  FETCH_CATEGORIES,
  FETCH_CATEGORY,
  UPDATE_CATEGORY,
  UPDATE_ACTIVATE_CATEGORY,
  FETCH_INACTIVE_CATEGORIES,
  FETCH_ACTIVE_CATEGORY,
  PATCH_CATEGORY_FIELDS,
  // DELETE_CATEGORY,
} from "../constants/categoryConstants";
import { categoryUraMappingFromLeaf } from "../utilities/uraMapping";
import * as api from "../api/index.js";

export const createCategory = (post) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    // const { data } = await dashboardApi.post("/category/create", post);
    const { data } = await dashboardApi.post(`/category/create`, post);

    dispatch({ type: CREATE_CATEGORY, payload: data });

    toast.success(data.message)

    dispatch({ type: END_LOADING });
    // callback();
  } catch (error) {
    console.log(error);
    toast.error(
      error?.response?.data?.message || error?.message || "Something went wrong."
    );
  }
};

export const getActiveCategories = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchActiveCategories();
    dispatch({
      type: FETCH_CATEGORIES,
      payload: data,
    });

    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

//Get Single Category
export const getCategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await dashboardApi.get(`/category/get-category/${id}`);
    dispatch({ type: FETCH_CATEGORY, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    toast.error(
      error?.response?.data?.message || error?.message || "Something went wrong."
    );
  }
};

export const getActiveCategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await dashboardApi.get(`/category/active/${id}`);

    dispatch({
      type: FETCH_ACTIVE_CATEGORY,
      payload: { category: data },
    });

    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const getInactiveCategories = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchDeactivatedCategories();
    // const { data } = await dashboardApi.get("/category/deactivated-categories");
    dispatch({
      type: FETCH_INACTIVE_CATEGORIES,
      payload: data,
    });

    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// Not in use currently
export const updateCategory = (id, updatedCategory) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await dashboardApi.patch(
      `/category/update/${id}`,
      updatedCategory
    );
    toast.success(data.message);
    
    dispatch({ type: UPDATE_CATEGORY, payload: data });

    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    toast.error(
      error?.response?.data?.message || error?.message || "Something went wrong."
    );
  }
};
/**
 * Inline URA mapping from the categories table. Saves ONLY the mapping fields
 * (`leaf` null clears them) and merges the result into the row in place, so
 * the table does not reload around every assignment.
 *
 * The row's name, picture and listings ride along unchanged because the update
 * handler reads all three from the body today (it walks `post_listings`), so a
 * body carrying only the URA fields would not be a safe partial update. The
 * server writes URA fields only when they are present in the body, which is
 * why nothing else about the mapping is sent.
 *
 * Returns { ok, message } rather than toasting on its own, like updateSiUnit.
 */
export const setCategoryUraMapping = (category, leaf) => async (dispatch) => {
  const mapping = categoryUraMappingFromLeaf(leaf);
  try {
    await dashboardApi.patch(`/category/update/${category._id}`, {
      category: category.category,
      category_pic: category.category_pic,
      post_listings: Array.isArray(category.post_listings) ? category.post_listings : [],
      ...mapping,
    });
    dispatch({
      type: PATCH_CATEGORY_FIELDS,
      payload: { _id: category._id, ...mapping, uraMappedAt: new Date().toISOString() },
    });
    return { ok: true };
  } catch (error) {
    console.log(error);
    /* The category handler answers `{ message: error }` with the raw error
       object on some paths, which is "[object Object]" to a toast. */
    const serverMessage = error?.response?.data?.message;
    return {
      ok: false,
      message:
        (typeof serverMessage === "string" && serverMessage) ||
        error?.message ||
        "Could not save the URA mapping.",
    };
  }
};

//Not deleting categories at the moment. We update it instead
// export const deleteCategory = (id) => async (dispatch) => {
//   try {
//     const { data } = await dashboardApi.delete(`/category/delete/${id}`);
//     console.log(data, "after deletion>>>")

//     dispatch({ type: DELETE_CATEGORY, payload: id, data });
//     toast.success("Category Deleted Successfully!");
//   } catch (error) {
//     console.log(error.response.statusText);
//     toast.error(error.response.statusText);
//   }
// };

export const deactivateCategory = (id) => async (dispatch) => {
  try {
    const { data } = await dashboardApi.put(`/category/deactivate/${id}`);

    dispatch({ type: UPDATE_CATEGORY, payload: id, data });
    toast.success("Category Deactivated Successfully!");
  } catch (error) {
    console.log(error);
    toast.error(
      error?.response?.data?.message || error?.message || "Something went wrong."
    );
  }
};

export const activateCategory = (id) => async (dispatch) => {
  try {
    const { data } = await dashboardApi.put(`/category/activate/${id}`);

    dispatch({ type: UPDATE_ACTIVATE_CATEGORY, payload: id, data });
    toast.success("Category Activated Successfully!");
  } catch (error) {
    console.log(error);
    toast.error(
      error?.response?.data?.message || error?.message || "Something went wrong."
    );
  }
};
